import ensurePath from 'redux/ensurePath'
import immerize from '../immerize'

function reducer(
  state = {
    status: '',
    error: null,
    history: {
      byid: {},
      list: [],
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
    log: null,
    typeahead: {
      staffId: [],
      device: [],
      name: [],
    },
    details: null,
  },
  action
) {
  const targetPanicHistory = ensurePath(state, ['history'])

  switch (action.type) {
    case 'CLEAR_STORE':
      state = defaultState()
      break
    case 'PANICS_FILTERED_HISTORY_FULFILLED':
    case 'PANICS_HISTORY_FULFILLED':
      normalizeHistory(state, action.payload.data)
      break
    case 'PANICS_HISTORY_CURRPAGE':
      targetPanicHistory.currentPage = action.payload.index
      break
    case 'PANICS_HISTORY_ITEMPERPAGE':
      targetPanicHistory.itemPerPage = action.payload.count
      targetPanicHistory.pageCount = Math.ceil(
        state.history.total / action.payload.count
      )
      targetPanicHistory.currentPage = 1
      break
    case 'PANICS_TYPEAHEAD_FULFILLED':
      targetPanicHistory.typeahead = action.payload.data
      break
    case 'PANICS_HISTORY_CLEAR':
      state.history = {
        ...state.history,
        byid: {},
        list: [],
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1,
      }
      break
    case 'PANICS_LOG_FULFILLED':
      state.log = action.payload.data
      break
    case 'PANICS_LOG_CLEAR':
      state.log = null
      break
    default:
      break
  }
  return state
}

function defaultState() {
  return {
    status: '',
    error: null,
    history: {
      byid: {},
      list: [],
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1,
    },
    log: null,
    typeahead: {
      staffId: [],
      device: [],
      name: [],
    },
    details: null,
  }
}

function normalizeHistory(state, data) {
  const targetPanicHistory = ensurePath(state, ['history'])

  if (state.history.list.length < 1 || state.history.total !== data.total) {
    targetPanicHistory.list = new Array(data.total).fill(-1)
  }
  const __list = [...state.history.list]
  __list.splice(data.skip, data.list.length, ...data.list)

  targetPanicHistory.byid = { ...state.history.byid, ...data.data }
  targetPanicHistory.list = __list
  targetPanicHistory.total = data.total
  targetPanicHistory.pageCount = Math.ceil(
    data.total / state.history.itemPerPage
  )
  targetPanicHistory.count = targetPanicHistory.list.length
}

export default immerize(reducer)
